// Shared card-language constants used by the buy-order form,
// order detail display, and seller fulfill/offer flows.
export const CARD_LANGUAGES = ["english", "japanese", "chinese", "korean", "other"] as const;
export type CardLanguage = (typeof CARD_LANGUAGES)[number];

const LABELS: Record<CardLanguage, string> = {
  english: "English",
  japanese: "Japanese",
  chinese: "Chinese",
  korean: "Korean",
  other: "Other",
};

export function languageLabel(v: string | null | undefined): string | null {
  if (!v) return null;
  const key = v.toLowerCase() as CardLanguage;
  return LABELS[key] ?? null;
}
